export function getNavEl() {
  return document.getElementById('hs-nav-v4');
}